import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgModule, OnChanges, Output, Renderer2, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FFacetInfoModule } from '@wipo/w-angular/internal';
import { FormsModule } from '@angular/forms';
import { WButtonModule } from '@wipo/w-angular/w-button';
import { WHideEmptyModule } from '@wipo/w-angular/directives';
import { WInputTextModule } from '@wipo/w-angular/w-input-text';
import { WLiButtonComponent } from './w-li-button/w-li-button.component';
import { CreateControlAccessProvider, ValueAccessor } from '@wipo/w-angular/shared';
import { WInputSearchModule } from '@wipo/w-angular/w-input-search';
import { WSelectOneModule } from '@wipo/w-angular/w-select-one';

@Component({
    selector: 'w-filter',
    providers: [CreateControlAccessProvider(WFilterComponent)],
    templateUrl: './w-filter.component.html',
    standalone: false
})
/*
@id w-filter
@name w-filter
@status release
@description
*/
export class WFilterComponent extends ValueAccessor implements AfterViewInit, OnChanges {
  @ViewChild('buttons') buttons!: TemplateRef<any>;
  @ViewChild('controls') controls!: TemplateRef<any>;
  @ViewChild('search') search!: TemplateRef<any>;
  private templateRefs: { [key: string]: TemplateRef<any> | undefined } = {};

  @Input() placeholder = 'Enter search string'; // search field placeholder
  @Input() tooltip = '';  // search field tooltip
  @Input() showSearch: boolean = false; // show/hide search button
  @Input() toggle: boolean = false; // toggle mode
  @Input() controlOrder = ['buttons', 'controls', 'search']; // section order 
  sections: TemplateRef<any>[] = [];
  @Output() wChange = new EventEmitter<string>(); // emits value when button clicked
  @Output() wKeyup = new EventEmitter<string>();  // emits value on each keystroke
  clear() {
    this.value = '';
    this.wChange.emit('');
  }
  keyup(event: KeyboardEvent) {
    this.wKeyup.emit(this.value);
    if (event.key === 'Enter') {
      this.wChange.emit(this.value);
    }
  }
  constructor(protected _renderer: Renderer2, protected _elementRef: ElementRef) { super(); }
  ngOnChanges(changes: SimpleChanges): void {
    const co = changes['controlOrder'];
    if (Array.isArray(this.controlOrder) && co?.currentValue !== co?.previousValue) {
      this.calculateSections();
    }
  }
  ngAfterViewInit() {
    this.initializeTemplateRefs();
    this.calculateSections();
  }
  private initializeTemplateRefs(): void {
    // Populate the dictionary with all available templates
    this.templateRefs = {
      'buttons': this.buttons,
      'controls': this.controls,
      'search': this.search,
    };
  }
  private calculateSections(): void{
    Promise.resolve().then(() => {
      this.sections = this.controlOrder
        .map(name => this.templateRefs[name])
        .filter((template): template is TemplateRef<any> => template !== undefined);
    });
  }
}
@NgModule({
  imports: [CommonModule, FormsModule,
    WHideEmptyModule,
    FFacetInfoModule,
    WInputTextModule, WInputSearchModule, WSelectOneModule,
    WButtonModule],
  exports: [WFilterComponent, WLiButtonComponent],
  declarations: [WFilterComponent, WLiButtonComponent]
})
export class WFilterModule { }
